/** Where an exported Word file was handed to the browser. */
export enum DocxDownloadSurface {
  Chat = 'chat',
}

/** Which control navigated to the Draft .docx exports folder. */
export enum DocxFolderSource {
  ChatCard = 'chatCard',
  DraftMenu = 'draftMenu',
}
